import { motion, useInView } from "framer-motion"
import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"

const ItinerariesSlider = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        // staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const itysliderData = useStaticQuery(graphql`
    query ityQuery {
      allWpItineraries(sort: { date: ASC }, limit: 5) {
        nodes {
          title
          excerpt
          uri
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          itinerariesContent {
            facilities
            stay
          }
        }
      }
    }
  `)

  const allItiData = itysliderData.allWpItineraries.nodes

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`itineraries-slider py-75 xlscreen:py-50 relative ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
          >
            <div className="container-fluid-xl">
              <div className="max-w-[573px] mx-auto text-center">
                {module?.heading && (
                  <motion.div
                    variants={animFade}
                    className="title title-grey grey-separator-both uppercase"
                  >
                    <h2>{module.heading}</h2>
                  </motion.div>
                )}
                {module?.description && (
                  <motion.div variants={animFade} className="content pt-15">
                    <p>{parse(module.description)}</p>
                  </motion.div>
                )}
              </div>
            </div>
            <motion.div
              variants={animFade}
              className="container-fluid-xl !pr-0 itineraries-slider-main pt-60 xlscreen:pt-45 mdscreen:pt-30"
            >
              <div className="relative mdscreen:container-fluid-sm">
                <Swiper
                  slidesPerView={2.7}
                  speed={1000}
                  modules={[Autoplay, Navigation]}
                  spaceBetween={35}
                  navigation={{
                    nextEl: ".itineraries_swiperBtn_next",
                    prevEl: ".itineraries_swiperBtn_prev",
                    disabledClass: "btn-disabled",
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2.7,
                      spaceBetween: 20,
                    },
                    1024: {
                      slidesPerView: 2.7,
                      spaceBetween: 35,
                    },
                  }}
                >
                  {allItiData.map((item, i) => (
                    <SwiperSlide key={i}>
                      <div className="items_wrapper">
                        <Link to={item.uri} className="relative block">
                          {item?.featuredImage && (
                            <div className="img">
                              <img
                                src={item.featuredImage.node.mediaItemUrl}
                                alt={item.featuredImage.node.title}
                                width={600}
                                height={1500}
                                loading="lazy"
                                className="object-cover"
                              />
                            </div>
                          )}
                          <div className="desc absolute top-0 left-0 h-full w-full py-40 px-20">
                            <div className="flex flex-col justify-between items-center h-full">
                              {item.itinerariesContent.stay && (
                                <motion.div
                                  variants={animFade}
                                  className="pre-heading white w-full text-center"
                                >
                                  <span>{item.itinerariesContent.stay}</span>
                                </motion.div>
                              )}
                              <div className="title_wrapper">
                                <motion.div
                                  variants={animFade}
                                  className="title title-white"
                                >
                                  <h5>{item.title}</h5>
                                </motion.div>
                                {item.itinerariesContent.facilities && (
                                  <div className="content_wrapper text-center pt-10">
                                    <div className="content white max-w-[198px] mx-auto uppercase">
                                      <p>
                                        {item.itinerariesContent.facilities}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <motion.div
                                variants={animFade}
                                className="custom-btn"
                              >
                                <span className="btn btn-underline-white">
                                  view itinerary
                                </span>
                              </motion.div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="swiper-arrow">
                  <button className="swiper-btn w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] absolute top-50per translate-y-minus_50 left-[200px] xlscreen:left-100 mdscreen2:left-60 smscreen2:left-30 z-9 rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-common itineraries_swiperBtn_prev">
                    <img
                      src="../../images/swiper-arrowPrev-white.svg"
                      width={20}
                      height={20}
                      loading="lazy"
                      alt="Arrow"
                      className="lgscreen:h-[15px] lgscreen:w-[15px]"
                    />
                  </button>
                  <button className="swiper-btn w-[42px] h-[42px] lgscreen:w-[35px] lgscreen:h-[35px] absolute top-50per translate-y-minus_50 right-[200px] xlscreen:right-100 mdscreen2:right-60 smscreen2:right-30 z-9 rounded-100 bg-opacity-10 border-2 border-white-100 flex flex-wrap justify-center items-center transition-common itineraries_swiperBtn_next">
                    <img
                      src="../../images/swiper-arrowNext-white.svg"
                      width={20}
                      height={20}
                      loading="lazy"
                      alt="Arrow"
                      className="lgscreen:h-[15px] lgscreen:w-[15px]"
                    />
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
  return null
}

export default ItinerariesSlider
export const PageItinerariesSliderFragment = graphql`
  fragment PageItinerariesSliderFragment on WpPage_Pagecontent_PageContent_ItinerariesSlider {
    extraClass
    extraId
    hideSection
    description
    heading
  }
`
